<div class="upsell-banner p-4">
  <div class="upsell-banner__container bg-lw-tan rounded-2xl max-w-6xl mx-auto pt-4 px-4 pb-0 desktop:pt-5 desktop:px-2.5">
    <div class="upsell-banner__wrapper w-full flex flex-col max-w-container desktop:flex-row items-center justify-center gap-4 desktop:gap-6">
      @if (bannerText) {
        <div class="upsell-banner__text text-center w-full desktop:w-auto" [innerHTML]="bannerText"></div>
      }
      @if (bannerImage) {
        <img class="upsell-banner__image w-full desktop:w-auto max-w-64 flex-shrink-0" [src]="bannerImage" alt="">
      }
    </div>
  </div>
</div>
